import { useMemo } from 'react';
import { getParamsDelimiter } from '../components/filter-tags/utils';
import { SearchFilterType } from '../types';

/**
 * Parses a range value string (e.g. from store params[field]) into a [start, end] tuple.
 * Value should come from SearchParamsStore via useSearchQueryFilter().params[field], not from URL.
 */
export function useParsedRangeValue<T>(
  value: string | undefined,
  type: SearchFilterType
) {
  return useMemo(() => {
    if (value) return value.split(getParamsDelimiter(type)) as T;
    return [undefined, undefined] as T;
  }, [value, type]);
}

/** @deprecated Use useParsedRangeValue. Kept for backward compatibility. */
export const useRangeValueFromSearchUrl = useParsedRangeValue;
